import { render, staticRenderFns } from "./IsActiveBadge.vue?vue&type=template&id=7ad49cd6"
import script from "./IsActiveBadge.vue?vue&type=script&lang=ts"
export * from "./IsActiveBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports